export default __webpack_public_path__ + "cbac2021317a35fe393cc34f0da75a04.svg";